"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeMongoDBSyncIncompatibleRoles = exports.MongoDBSyncIncompatibleRoles = exports.MongoDBSyncIncompatibleNamespaceRole = exports.MongoDBSyncIncompatibleRole = exports.MongoDBSyncIncompatibilityError = exports.MongoDBNamespace = exports.RulesConverter = exports.deserializePartialRule = exports.isPartialRuleBuiltin = exports.isPartialRuleMongoDBNamespace = exports.deserializeRule = exports.isRuleBuiltin = exports.isRuleMongoDBNamespace = exports.deserializeBaseRule = exports.PartialBuiltinRule = exports.BuiltinRule = exports.PartialMongoDBNamespaceRule = exports.MongoDBNamespaceRule = exports.MongoDBBaseRule = exports.MongoDBRuleFilter = exports.PresetRole = exports.MongoDBRuleRole = exports.MongoDBRuleField = exports.MongoDBRulePermissions = exports.MongoDBRuleRelationship = void 0;
var Schema_1 = require("./Schema");
var json2typescript_1 = require("json2typescript");
var jsonConvert = new json2typescript_1.JsonConvert();
exports.MongoDBRuleRelationship = Schema_1.Relationship;
var MongoDBRulePermissions = (function () {
    function MongoDBRulePermissions(partial) {
        this.write = undefined;
        this.read = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('write', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRulePermissions.prototype, "write", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('read', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRulePermissions.prototype, "read", void 0);
    MongoDBRulePermissions = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBRulePermissions'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRulePermissions);
    return MongoDBRulePermissions;
}());
exports.MongoDBRulePermissions = MongoDBRulePermissions;
var MongoDBRuleField = (function () {
    function MongoDBRuleField(partial) {
        this.fields = undefined;
        this.read = undefined;
        this.write = undefined;
        this.additionalFields = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('fields', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "fields", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('read', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "read", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('write', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleField.prototype, "write", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('additional_fields', MongoDBRulePermissions, true),
        __metadata("design:type", MongoDBRulePermissions)
    ], MongoDBRuleField.prototype, "additionalFields", void 0);
    MongoDBRuleField = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBRuleField'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleField);
    return MongoDBRuleField;
}());
exports.MongoDBRuleField = MongoDBRuleField;
var serializeMongoDBRuleField = function (ruleField) {
    var ruleFieldData = jsonConvert.serializeObject(ruleField, MongoDBRuleField);
    if (ruleField.fields) {
        var fields = Object.entries(ruleField.fields).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = serializeMongoDBRuleField(fieldData), _b)));
        }, {});
        ruleFieldData = __assign(__assign({}, ruleFieldData), { fields: fields });
    }
    return ruleFieldData;
};
var deserializeMongoDBRuleField = function (data) {
    var ruleField = jsonConvert.deserializeObject(data, MongoDBRuleField);
    if ('fields' in data) {
        var fields = Object.entries(data.fields).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = deserializeMongoDBRuleField(fieldData), _b)));
        }, {});
        ruleField = new MongoDBRuleField(__assign(__assign({}, ruleField), { fields: fields }));
    }
    return ruleField;
};
var MongoDBRuleFieldMapConverter = (function () {
    function MongoDBRuleFieldMapConverter() {
    }
    MongoDBRuleFieldMapConverter.prototype.serialize = function (fieldMap) {
        return Object.entries(fieldMap).reduce(function (dataMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldRule = _c[1];
            return (__assign(__assign({}, dataMap), (_b = {}, _b[key] = serializeMongoDBRuleField(fieldRule), _b)));
        }, {});
    };
    MongoDBRuleFieldMapConverter.prototype.deserialize = function (data) {
        return Object.entries(data).reduce(function (fieldMap, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], fieldData = _c[1];
            return (__assign(__assign({}, fieldMap), (_b = {}, _b[key] = deserializeMongoDBRuleField(fieldData), _b)));
        }, {});
    };
    MongoDBRuleFieldMapConverter = __decorate([
        json2typescript_1.JsonConverter
    ], MongoDBRuleFieldMapConverter);
    return MongoDBRuleFieldMapConverter;
}());
var MongoDBRuleRole = (function () {
    function MongoDBRuleRole(partial) {
        this.name = '';
        this.applyWhen = {};
        this.documentFilters = undefined;
        this.fields = undefined;
        this.read = undefined;
        this.write = undefined;
        this.insert = undefined;
        this.delete = undefined;
        this.search = undefined;
        this.additionalFields = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('apply_when'),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "applyWhen", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('document_filters', MongoDBRulePermissions, true),
        __metadata("design:type", MongoDBRulePermissions)
    ], MongoDBRuleRole.prototype, "documentFilters", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('fields', MongoDBRuleFieldMapConverter, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "fields", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('read', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "read", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('write', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "write", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('insert', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "insert", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('delete', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "delete", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('search', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleRole.prototype, "search", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('additional_fields', MongoDBRulePermissions, true),
        __metadata("design:type", MongoDBRulePermissions)
    ], MongoDBRuleRole.prototype, "additionalFields", void 0);
    MongoDBRuleRole = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBRuleRole'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleRole);
    return MongoDBRuleRole;
}());
exports.MongoDBRuleRole = MongoDBRuleRole;
var PresetRole = (function () {
    function PresetRole(partial) {
        this.name = '';
        this.roles = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], PresetRole.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('roles', [MongoDBRuleRole], true),
        __metadata("design:type", Array)
    ], PresetRole.prototype, "roles", void 0);
    PresetRole = __decorate([
        (0, json2typescript_1.JsonObject)('PresetRole'),
        __metadata("design:paramtypes", [Object])
    ], PresetRole);
    return PresetRole;
}());
exports.PresetRole = PresetRole;
var MongoDBRuleFilter = (function () {
    function MongoDBRuleFilter(partial) {
        this.name = '';
        this.query = {};
        this.projection = undefined;
        this.applyWhen = {};
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('query'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "query", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('projection', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "projection", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('apply_when'),
        __metadata("design:type", Object)
    ], MongoDBRuleFilter.prototype, "applyWhen", void 0);
    MongoDBRuleFilter = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBRuleFilter'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBRuleFilter);
    return MongoDBRuleFilter;
}());
exports.MongoDBRuleFilter = MongoDBRuleFilter;
var MongoDBBaseRule = (function () {
    function MongoDBBaseRule(partial) {
        this.id = undefined;
        this.filters = undefined;
        this.roles = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String, true),
        __metadata("design:type", String)
    ], MongoDBBaseRule.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('filters', [MongoDBRuleFilter], true),
        __metadata("design:type", Array)
    ], MongoDBBaseRule.prototype, "filters", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('roles', [MongoDBRuleRole], true),
        __metadata("design:type", Array)
    ], MongoDBBaseRule.prototype, "roles", void 0);
    MongoDBBaseRule = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBBaseRule'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBBaseRule);
    return MongoDBBaseRule;
}());
exports.MongoDBBaseRule = MongoDBBaseRule;
var MongoDBNamespaceRule = (function (_super) {
    __extends(MongoDBNamespaceRule, _super);
    function MongoDBNamespaceRule(partial) {
        var _this = _super.call(this, partial) || this;
        _this.database = '';
        _this.collection = '';
        _this.schema = undefined;
        _this.relationships = undefined;
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('database'),
        __metadata("design:type", Object)
    ], MongoDBNamespaceRule.prototype, "database", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('collection'),
        __metadata("design:type", Object)
    ], MongoDBNamespaceRule.prototype, "collection", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('schema', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBNamespaceRule.prototype, "schema", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('relationships', Schema_1.RelationshipMapConverter, true),
        __metadata("design:type", Object)
    ], MongoDBNamespaceRule.prototype, "relationships", void 0);
    MongoDBNamespaceRule = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBNamespaceRule'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBNamespaceRule);
    return MongoDBNamespaceRule;
}(MongoDBBaseRule));
exports.MongoDBNamespaceRule = MongoDBNamespaceRule;
var PartialMongoDBNamespaceRule = (function () {
    function PartialMongoDBNamespaceRule(partial) {
        this.id = '';
        this.database = '';
        this.collection = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialMongoDBNamespaceRule.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('database'),
        __metadata("design:type", Object)
    ], PartialMongoDBNamespaceRule.prototype, "database", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('collection'),
        __metadata("design:type", Object)
    ], PartialMongoDBNamespaceRule.prototype, "collection", void 0);
    PartialMongoDBNamespaceRule = __decorate([
        (0, json2typescript_1.JsonObject)('PartialMongoDBNamespaceRule'),
        __metadata("design:paramtypes", [Object])
    ], PartialMongoDBNamespaceRule);
    return PartialMongoDBNamespaceRule;
}());
exports.PartialMongoDBNamespaceRule = PartialMongoDBNamespaceRule;
var BuiltinRule = (function () {
    function BuiltinRule(partial) {
        this.id = undefined;
        this.name = '';
        this.actions = [];
        this.when = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String, true),
        __metadata("design:type", String)
    ], BuiltinRule.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], BuiltinRule.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('actions', [String]),
        __metadata("design:type", Array)
    ], BuiltinRule.prototype, "actions", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('when', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], BuiltinRule.prototype, "when", void 0);
    BuiltinRule = __decorate([
        (0, json2typescript_1.JsonObject)('BuiltinRule'),
        __metadata("design:paramtypes", [Object])
    ], BuiltinRule);
    return BuiltinRule;
}());
exports.BuiltinRule = BuiltinRule;
var PartialBuiltinRule = (function () {
    function PartialBuiltinRule(partial) {
        this.id = '';
        this.name = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialBuiltinRule.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], PartialBuiltinRule.prototype, "name", void 0);
    PartialBuiltinRule = __decorate([
        (0, json2typescript_1.JsonObject)('PartialBuiltinRule'),
        __metadata("design:paramtypes", [Object])
    ], PartialBuiltinRule);
    return PartialBuiltinRule;
}());
exports.PartialBuiltinRule = PartialBuiltinRule;
var deserializeBaseRule = function (data) {
    return jsonConvert.deserializeObject(data, MongoDBBaseRule);
};
exports.deserializeBaseRule = deserializeBaseRule;
var isRuleMongoDBNamespace = function (rule) {
    return 'database' in rule;
};
exports.isRuleMongoDBNamespace = isRuleMongoDBNamespace;
var isRuleBuiltin = function (rule) { return !('database' in rule); };
exports.isRuleBuiltin = isRuleBuiltin;
var deserializeRule = function (data) {
    if ('database' in data) {
        return jsonConvert.deserializeObject(data, MongoDBNamespaceRule);
    }
    return jsonConvert.deserializeObject(data, BuiltinRule);
};
exports.deserializeRule = deserializeRule;
var isPartialRuleMongoDBNamespace = function (rule) { return 'database' in rule; };
exports.isPartialRuleMongoDBNamespace = isPartialRuleMongoDBNamespace;
var isPartialRuleBuiltin = function (rule) { return !('database' in rule); };
exports.isPartialRuleBuiltin = isPartialRuleBuiltin;
var deserializePartialRule = function (data) {
    if ('database' in data) {
        return jsonConvert.deserializeObject(data, PartialMongoDBNamespaceRule);
    }
    return jsonConvert.deserializeObject(data, PartialBuiltinRule);
};
exports.deserializePartialRule = deserializePartialRule;
var RulesConverter = (function () {
    function RulesConverter() {
    }
    RulesConverter.prototype.serialize = function (rules) {
        return jsonConvert.serializeArray(rules);
    };
    RulesConverter.prototype.deserialize = function (rulesData) {
        if (!(rulesData instanceof Array)) {
            throw new Error('expected rules to be an array');
        }
        return Object.values(rulesData).map(exports.deserializeRule);
    };
    RulesConverter = __decorate([
        json2typescript_1.JsonConverter
    ], RulesConverter);
    return RulesConverter;
}());
exports.RulesConverter = RulesConverter;
var MongoDBNamespace = (function () {
    function MongoDBNamespace(partial) {
        this.Database = '';
        this.Collections = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('Database'),
        __metadata("design:type", Object)
    ], MongoDBNamespace.prototype, "Database", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('Collections'),
        __metadata("design:type", Array)
    ], MongoDBNamespace.prototype, "Collections", void 0);
    MongoDBNamespace = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBNamespace'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBNamespace);
    return MongoDBNamespace;
}());
exports.MongoDBNamespace = MongoDBNamespace;
var MongoDBSyncIncompatibilityError = (function () {
    function MongoDBSyncIncompatibilityError(partial) {
        this.key = '';
        this.errorMessages = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('key'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibilityError.prototype, "key", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('error_messages'),
        __metadata("design:type", Array)
    ], MongoDBSyncIncompatibilityError.prototype, "errorMessages", void 0);
    MongoDBSyncIncompatibilityError = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBSyncIncompatibilityError'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBSyncIncompatibilityError);
    return MongoDBSyncIncompatibilityError;
}());
exports.MongoDBSyncIncompatibilityError = MongoDBSyncIncompatibilityError;
var MongoDBSyncIncompatibleRole = (function () {
    function MongoDBSyncIncompatibleRole(partial) {
        this.name = '';
        this.errors = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleRole.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('errors', [MongoDBSyncIncompatibilityError]),
        __metadata("design:type", Array)
    ], MongoDBSyncIncompatibleRole.prototype, "errors", void 0);
    MongoDBSyncIncompatibleRole = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBSyncIncompatibleRole'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBSyncIncompatibleRole);
    return MongoDBSyncIncompatibleRole;
}());
exports.MongoDBSyncIncompatibleRole = MongoDBSyncIncompatibleRole;
var MongoDBSyncIncompatibleNamespaceRole = (function (_super) {
    __extends(MongoDBSyncIncompatibleNamespaceRole, _super);
    function MongoDBSyncIncompatibleNamespaceRole(partial) {
        var _this = _super.call(this, partial) || this;
        _this.database = '';
        _this.collection = '';
        _this.existsInSchema = false;
        Object.assign(_this, partial);
        return _this;
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('database'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleNamespaceRole.prototype, "database", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('collection'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleNamespaceRole.prototype, "collection", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('exists_in_schema'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleNamespaceRole.prototype, "existsInSchema", void 0);
    MongoDBSyncIncompatibleNamespaceRole = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBSyncIncompatibleNamespaceRole'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBSyncIncompatibleNamespaceRole);
    return MongoDBSyncIncompatibleNamespaceRole;
}(MongoDBSyncIncompatibleRole));
exports.MongoDBSyncIncompatibleNamespaceRole = MongoDBSyncIncompatibleNamespaceRole;
var MongoDBSyncIncompatibleRoles = (function () {
    function MongoDBSyncIncompatibleRoles(partial) {
        this.namespaceRoles = undefined;
        this.defaultRoles = undefined;
        this.namespacesUsingDefaultRule = undefined;
        this.flexibleSyncEnabled = true;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('namespace_roles', [MongoDBSyncIncompatibleNamespaceRole], true),
        __metadata("design:type", Array)
    ], MongoDBSyncIncompatibleRoles.prototype, "namespaceRoles", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('default_roles', [MongoDBSyncIncompatibleRole], true),
        __metadata("design:type", Array)
    ], MongoDBSyncIncompatibleRoles.prototype, "defaultRoles", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('namespaces_using_default_rule', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleRoles.prototype, "namespacesUsingDefaultRule", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('flexible_sync_enabled'),
        __metadata("design:type", Object)
    ], MongoDBSyncIncompatibleRoles.prototype, "flexibleSyncEnabled", void 0);
    MongoDBSyncIncompatibleRoles = __decorate([
        (0, json2typescript_1.JsonObject)('MongoDBSyncIncompatibleRoles'),
        __metadata("design:paramtypes", [Object])
    ], MongoDBSyncIncompatibleRoles);
    return MongoDBSyncIncompatibleRoles;
}());
exports.MongoDBSyncIncompatibleRoles = MongoDBSyncIncompatibleRoles;
var deserializeMongoDBSyncIncompatibleRoles = function (data) {
    return jsonConvert.deserializeObject(data, MongoDBSyncIncompatibleRoles);
};
exports.deserializeMongoDBSyncIncompatibleRoles = deserializeMongoDBSyncIncompatibleRoles;
//# sourceMappingURL=Rule.js.map